import './ins_dashboard/public/js/ins_dashboard_app.js';
import './ins_dashboard/public/js/components/google_account_settings.js';
import './ins_dashboard/public/js/components/filters.js';
import './ins_dashboard/public/js/components/google_analytics_highchart.js';
import './ins_dashboard/public/js/controllers/widget_ctrl.js';
import './ins_dashboard/public/js/services/google_analytics_service.js';
import './ins_dashboard/public/js/services/insights-backend-service.js';
import './ins_dashboard/public/js/services/nav_bar_state_change_service.js';
import './ins_dashboard/public/js/services/google_account_service.js';
import './ins_dashboard/public/js/services/chart_data_service.js';
import './ins_dashboard/public/js/services/chart_service.js';
import './ins_dashboard/public/js/services/google_analytics_error_service.js';
import './ins_dashboard/public/js/services/social_reach_service.js';
import './ins_dashboard/public/js/services/ins_widget_config_service.js';
import './ins_dashboard/public/js/services/widgets/social_reach/social_reach_tooltip_renderer.js';
import './ins_dashboard/public/js/services/widgets/social_reach/grouped_bar_chart_data_formatter.js';
import './ins_dashboard/public/js/services/widgets/social_reach/bar_chart_data_formatter.js';
import './ins_dashboard/public/js/services/widgets/social_reach/social_reach_chart_data_formatting_service.js';
import './ins_dashboard/public/js/services/widgets/data_maps/insights_data_maps.js';
import './ins_dashboard/public/js/services/widgets/transforms/transform_sov.js';
import './ins_dashboard/public/js/services/widgets/transforms/transform_segment.js';
import './ins_dashboard/public/js/services/widgets/transforms/transform_ave.js';
import './ins_dashboard/public/js/services/widgets/transforms/transform_sentiment.js';
import './ins_dashboard/public/js/services/widgets/transforms/transform_sentiment_score.js';
import './widgets/ave-widget/ave_widget.js';
import './widgets/geo-segment-widget/geo_segment_widget.js';
import './widgets/google-analytics-widget/google_analytics_widget.js';
import './widgets/image-widget/image_widget.js';
import './widgets/keyphrase-trend-widget/keyphrase_trend_widget.js';
import './widgets/momentum-widget/momentum_widget.js';
import './widgets/reach-widget/reach_widget.js';
import './widgets/search-list-widget/search_list_widget.js';
import './widgets/sentiment-score-widget/sentiment_score_widget.js';
import './widgets/sentiment-widget/sentiment_widget.js';
import './widgets/social-reach-widget/social_reach_widget.js';
import './widgets/source-segment-widget/source_segment_widget.js';
import './widgets/sov-widget/sov_widget.js';
import './widgets/text-widget/text_widget.js';
import './widgets/top-lang-widget/top_lang_widget.js';
import './widgets/top-posters-widget/top_posters_widget.js';
import './widgets/volume-widget/volume_widget.js';
import './v11n/public/js/v11n_app.js';
import './v11n/public/js/v11n_mock.js';
import './widgets/heat-map-widget/map_highcharts.js';
import './widgets/heat-map-widget/heat_map_widget.js';
import './widgets/heat-map-widget/map_service.js';
import './widgets/index.js';

angular.module('MW.LegacyWidget.App', ['MW.Dashboard.WidgetComponents', 'insDashboardApp', 'v11nApp']);
